(function () {
  'use strict';

  if (window.notify_me_initialized) return;
  window.notify_me_initialized = true;

  var overlay = document.getElementById('notify-me-overlay');
  var modal = document.getElementById('notify-me-modal');
  var closeBtn = document.getElementById('notify-me-modal-close');
  var formView = document.getElementById('notify-me-modal-form');
  var thanksView = document.getElementById('notify-me-modal-thanks');
  var headingEl = document.getElementById('notify-me-modal-heading');
  var form = document.getElementById('notify-me-form');
  var emailInput = document.getElementById('notify-me-email');
  var phoneInput = document.getElementById('notify-me-phone');
  var emailError = document.getElementById('notify-me-email-error');
  var phoneError = document.getElementById('notify-me-phone-error');
  var submitBtn = document.getElementById('notify-me-submit');

  if (!overlay || !modal || !form) return;

  var strings = window.notifyMeStrings || {};
  var currentTrigger = null;

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
  }

  function isValidPhone(value) {
    return /^[6-9]\d{9}$/.test(value.trim());
  }

  function setFieldError(input, errorEl, message) {
    input.closest('.notify-me-field').classList.toggle('has-error', !!message);
    errorEl.textContent = message || '';
  }

  function validate() {
    // Email is optional — only invalid when the shopper has typed something malformed.
    var emailValid = emailInput.value.trim() === '' || isValidEmail(emailInput.value);
    var phoneValid = isValidPhone(phoneInput.value);

    setFieldError(emailInput, emailError, emailInput.value && !emailValid ? strings.emailInvalid : '');
    setFieldError(phoneInput, phoneError, phoneInput.value && !phoneValid ? strings.phoneInvalid : '');

    submitBtn.disabled = !(emailValid && phoneValid);
    return emailValid && phoneValid;
  }

  function resetForm() {
    form.reset();
    phoneInput.value = phoneInput.value.replace(/\D/g, '').slice(-10);
    setFieldError(emailInput, emailError, '');
    setFieldError(phoneInput, phoneError, '');
    formView.classList.remove('hidden');
    thanksView.classList.add('hidden');
    validate();
  }

  function openPopup(trigger) {
    currentTrigger = trigger;
    if (headingEl) {
      var titleEl = headingEl.querySelector('strong');
      if (titleEl) titleEl.textContent = trigger.dataset.productTitle || '';
    }
    resetForm();
    overlay.classList.remove('hidden');
    modal.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
    emailInput.focus();
  }

  function closePopup() {
    overlay.classList.add('hidden');
    modal.classList.add('hidden');
    document.body.style.overflow = '';
    currentTrigger = null;
  }

  function pushToClevertap(payload) {
    if (!window.clevertap) return;

    var profile = { Phone: payload.phone };
    if (payload.email) profile.Email = payload.email;

    if (!sessionStorage.getItem('notify_me_profile_created')) {
      window.clevertap.profile.push({ Site: profile });
      sessionStorage.setItem('notify_me_profile_created', '1');
    }

    var eventData = {
      'Product ID': payload.productId,
      'Variant ID': payload.variantId,
      'Product Title': payload.productTitle,
      SKU: payload.sku,
      Price: payload.price,
      'Compare At Price': payload.compareAtPrice,
      Phone: payload.phone
    };
    if (payload.email) eventData.Email = payload.email;


    var BACK_IN_STOCK_LOG_URL = 'https://script.google.com/macros/s/AKfycbxB6RR7X1WHPlRUUZw38M3Y7k8u9i5CK6wwX5HIQ86JljmBb4_fOJmhzayHFRMH_6iP/exec';
    if (BACK_IN_STOCK_LOG_URL.indexOf('http') === 0) {
      try {
        fetch(BACK_IN_STOCK_LOG_URL, {
          method: 'POST',
          mode: 'no-cors',
          keepalive: true,
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify({
            email: payload.email,
            phone: payload.phone,
            variant_id: payload.variantId,
            sku: payload.sku,
            product_name: payload.productTitle,
            variant_title: payload.productTitle,
            product_id: payload.productId
          })
        }).catch(function () {});
      } catch (e) {}
    }

    window.clevertap.event.push('Notify Me Submitted', eventData);
  }

  function markTriggerNotified(trigger) {
    trigger.textContent = strings.notified || 'Notified';
    trigger.disabled = true;
    trigger.classList.add('is-notified');
  }

  function handleSubmit(event) {
    event.preventDefault();
    if (!validate() || !currentTrigger) return;

    var trigger = currentTrigger;
    pushToClevertap({
      productId: trigger.dataset.productId,
      variantId: trigger.dataset.variantId,
      productTitle: trigger.dataset.productTitle,
      sku: trigger.dataset.sku,
      price: trigger.dataset.price,
      compareAtPrice: trigger.dataset.compareAtPrice,
      email: emailInput.value.trim(),
      phone: '+91' + phoneInput.value.trim()
    });

    formView.classList.add('hidden');
    thanksView.classList.remove('hidden');
    markTriggerNotified(trigger);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.notify-me-btn');
    if (trigger) {
      event.preventDefault();
      openPopup(trigger);
      return;
    }

    if (event.target === overlay || event.target.closest('#notify-me-modal-close')) {
      closePopup();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.classList.contains('hidden')) {
      closePopup();
    }
  });

  emailInput.addEventListener('input', validate);
  phoneInput.addEventListener('input', function () {
    phoneInput.value = phoneInput.value.replace(/\D/g, '').slice(0, 10);
    validate();
  });

  form.addEventListener('submit', handleSubmit);

  // Keep live-synced buttons (PDP add-to-cart siblings) in step with client-side
  // variant switching, since they aren't touched by the theme's own fetch/DOM-swap logic.
  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    document.querySelectorAll('.notify-me-btn[data-live="true"]').forEach(function (btn) {
      if (variant.available) {
        btn.setAttribute('hidden', 'hidden');
      } else {
        btn.removeAttribute('hidden');
      }
      btn.dataset.variantId = variant.id;
      if (variant.sku !== undefined) btn.dataset.sku = variant.sku;
    });
  });
})();
